module.exports = __webpack_public_path__ + "img/snack.aad326d.png";